import { Box, IconButton, styled, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import AccountBadge from "../common/AccountBadge";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StopIcon from "@mui/icons-material/Stop";
import { useViewport } from "../../helpers";
import { useSelector } from "react-redux";

const PREFIX = "PurchaseGeolocHeader";

const classes = {
  imageContainer: `${PREFIX}-imageContainer`,
  image: `${PREFIX}-image`,
  imageGradient: `${PREFIX}-imageGradient`,
  accountBadgeContainer: `${PREFIX}-accountBadgeContainer`,
  playButtonIcon: `${PREFIX}-playButtonIcon`,
  exparienceNameContainer: `${PREFIX}-exparienceNameContainer`,
  exparienceName: `${PREFIX}-exparienceName`,
};

const PurchaseGeolocHeaderContainer = styled("div")(({ theme }) => ({
  [`& .${classes.imageContainer}`]: {
    position: "relative",
    width: "100%",
    height: "40vh",
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "40vh",
      overflow: "hidden",
    },
  },

  [`& .${classes.image}`]: {
    height: "100%",
    width: "100%",
    objectFit: "contain",
    objectPosition: "center",
    [theme.breakpoints.down("md")]: {
      objectFit: "cover",
    },
  },

  [`& .${classes.imageGradient}`]: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "50%",
    background:
      "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%)",
    pointerEvents: "none",
  },

  [`& .${classes.accountBadgeContainer}`]: {
    display: "flex",
    position: "absolute",
    top: "25px",
    right: "25px",
    [theme.breakpoints.down("md")]: {
      top: "5%",
      right: "5%",
    },
  },

  [`& .${classes.playButtonIcon}`]: {
    width: "30px",
    height: "30px",
    background: "#D3AF5F",
    borderRadius: "50%",
    boxShadow: "0px 0px 6px 2px rgba(0,0,0,0.9)",
  },

  [`& .${classes.exparienceNameContainer}`]: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: "5%",
    marginInline: "auto",
    width: "95%",
    [theme.breakpoints.down("md")]: {
      textAlign: "center",
    },
  },

  [`& .${classes.exparienceName}`]: {
    padding: "0 10px",
    whiteSpace: "normal",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
  },
}));

const PurchaseGeolocHeader = ({ exparienceData }) => {
  const { t } = useTranslation();
  const { width } = useViewport();
  const loggedIn = useSelector((state) => state.user.loggedIn);

  const [videoPlaying, setVideoPlaying] = useState(false);

  const videoRef = useRef(null);

  /**
   * Ajustement du volume au lancement de la vidéo
   */
  useEffect(() => {
    if (videoPlaying && videoRef.current) {
      videoRef.current.volume = 0.2;
    }
  }, [videoPlaying]);

  return (
    <PurchaseGeolocHeaderContainer>
      <Box className={classes.imageContainer}>
        {exparienceData?.promotedVideoUrl && videoPlaying ? (
          <Box
            component="video"
            ref={videoRef}
            src={exparienceData?.promotedVideoUrl}
            autoPlay
            controls
            className={classes.image}
          />
        ) : (
          <Box
            component="img"
            src={exparienceData?.promotedLogoUrl || exparienceData?.logoUrl}
            alt={t("purchaseGeoloc.exparienceLogo")}
            className={classes.image}
          />
        )}
        {!videoPlaying && <Box className={classes.imageGradient} />}
        {exparienceData?.promotedVideoUrl &&
          (!videoPlaying ? (
            <Box className={classes.accountBadgeContainer}>
              <IconButton
                className={classes.playButtonIcon}
                onClick={() => setVideoPlaying(true)}
                sx={{
                  marginRight: loggedIn ? "15px" : 0,
                }}
              >
                <PlayArrowIcon sx={{ color: "#121212" }} />
              </IconButton>
              {loggedIn && <AccountBadge isOnImage />}
            </Box>
          ) : (
            <Box className={classes.accountBadgeContainer}>
              <IconButton
                className={classes.playButtonIcon}
                onClick={() => setVideoPlaying(false)}
                sx={{}}
              >
                <StopIcon sx={{ color: "#121212" }} />
              </IconButton>
            </Box>
          ))}
        {!videoPlaying && (
          <Box className={classes.exparienceNameContainer}>
            <Typography
              variant={width > 768 ? "h2" : "h3"}
              className={classes.exparienceName}
            >
              {exparienceData?.name
                ? exparienceData?.displayName.toUpperCase()
                : exparienceData?.name}
            </Typography>
          </Box>
        )}
      </Box>
    </PurchaseGeolocHeaderContainer>
  );
};

export default PurchaseGeolocHeader;
